import { ThemeBlockBackgroundValue, FormBlockBackgroundValue } from '../Properties/BlockBackgroundValue.js';
import PropertyType from '../Modifiers/PropertyType.js';

var BlockBackgroundTypeOptions = /*#__PURE__*/function (BlockBackgroundTypeOptions) {
  BlockBackgroundTypeOptions["color"] = "color";
  return BlockBackgroundTypeOptions;
}(BlockBackgroundTypeOptions || {});
var themeBackgroundTypeFunction = function themeBackgroundTypeFunction(backgroundType) {
  var backgroundValue = ThemeBlockBackgroundValue.getValue();
  switch (backgroundType) {
    case BlockBackgroundTypeOptions.color:
    default:
      return "background-color: " + backgroundValue + "; backdrop-filter: blur(8px);";
  }
};
var formBackgroundTypeFunction = function formBackgroundTypeFunction(backgroundType) {
  var backgroundValue = FormBlockBackgroundValue.getValue();
  switch (backgroundType) {
    case BlockBackgroundTypeOptions.color:
    default:
      return "background-color: " + backgroundValue + "; backdrop-filter: blur(8px);";
  }
};
var ThemeBlockBackgroundType = new PropertyType({
  name: 'BlockBackgroundType',
  propertyFromApi: 'block-background-type',
  convertValueToCssPropertiesFunction: themeBackgroundTypeFunction,
  defaultValue: 'color',
  options: BlockBackgroundTypeOptions,
  selector: '.block',
  isCompounded: true
}, 'theme');
var FormBlockBackgroundType = new PropertyType({
  name: 'BlockBackgroundType',
  propertyFromApi: 'block-background-type',
  convertValueToCssPropertiesFunction: formBackgroundTypeFunction,
  defaultValue: 'color',
  options: BlockBackgroundTypeOptions,
  selector: '.block',
  isCompounded: true
}, 'form');

export { FormBlockBackgroundType, ThemeBlockBackgroundType };
//# sourceMappingURL=BlockBackgroundType.js.map
